{
  "actions": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "continue": "متابعة",
    "back": "رجوع",
    "close": "إغلاق",
    "copy": "نسخ",
    "copied": "تم النسخ",
    "edit": "تعديل",
    "delete": "حذف",
    "remove": "إزالة",
    "retry": "إعادة المحاولة",
    "search": "بحث",
    "clear": "مسح",
    "view": "عرض",
    "viewAll": "عرض الكل",
    "learnMore": "اعرف أكثر",
    "next": "التالي",
    "previous": "السابق",
    "done": "تم",
    "confirm": "تأكيد",
    "finish": "إنهاء",
    "dismiss": "إخفاء",
    "add": "إضافة",
    "open": "فتح",
    "download": "تنزيل",
    "export": "تصدير",
    "refresh": "تحديث"
  },
  "currency": {
    "sar": "ريال سعودي"
  },
  "stub": {
    "title": "هذا القسم قيد الإعداد",
    "body": "نعمل على هذه الصفحة الآن."
  },
  "states": {
    "license": {
      "pending_activation": "بانتظار التفعيل",
      "trial": "تجربة",
      "valid": "فعّال",
      "grace": "مهلة بدون اتصال",
      "degraded": "مقيّد بدون اتصال",
      "expired": "ترخيص منتهي",
      "past_due": "متأخر السداد",
      "locked": "مقفل"
    },
    "subscription": {
      "trialing": "تجربة",
      "active": "فعّال",
      "past_due": "متأخر السداد",
      "pending": "بانتظار التفعيل",
      "incomplete": "بانتظار الدفع",
      "ended": "منتهي"
    },
    "invoice": {
      "open": "غير مدفوعة",
      "paid": "مدفوعة",
      "failed": "فشل الدفع",
      "void": "ملغاة",
      "refunded": "مستردة"
    },
    "payment": {
      "pending": "معلّقة",
      "processing": "قيد المعالجة",
      "paid": "مدفوعة",
      "failed": "فشلت",
      "refunded": "مستردة"
    }
  },
  "roles": {
    "owner": "المالك",
    "admin": "مدير",
    "billing": "الفوترة",
    "technical": "تقني"
  },
  "roleDescriptions": {
    "owner": "كل الصلاحيات، ومنها نقل الملكية وحذف الحساب.",
    "admin": "كل الصلاحيات ما عدا الملكية.",
    "billing": "تغيير الباقات وطرق الدفع والفواتير ونقاط الذكاء الاصطناعي.",
    "technical": "السيرفرات ومفاتيح التفعيل والتثبيت والدعم."
  },
  "countries": {
    "SA": "السعودية",
    "AE": "الإمارات",
    "KW": "الكويت",
    "QA": "قطر",
    "BH": "البحرين",
    "OM": "عُمان"
  },
  "cycle": {
    "label": "دورة الفوترة",
    "monthly": "شهري",
    "yearly": "سنوي",
    "save": "وفّر {{pct}}٪"
  },
  "os": {
    "debian-12": "Debian 12",
    "ubuntu-22.04": "Ubuntu 22.04 LTS",
    "ubuntu-24.04": "Ubuntu 24.04 LTS"
  },
  "channel": {
    "stable": "مستقر",
    "beta": "تجريبي"
  },
  "terms": {
    "subscriptionStatus": "حالة الاشتراك",
    "activationKey": "مفتاح التفعيل",
    "aiCredits": "نقاط الذكاء الاصطناعي",
    "hostingAccounts": "حسابات الاستضافة"
  },
  "plans": {
    "taglines": {
      "solo": "للمستقلين الذين يديرون مواقعهم على سيرفر واحد",
      "team": "للمطورين والوكالات الصغيرة",
      "pro": "للوكالات الكبيرة وشركات الاستضافة الناشئة",
      "host": "لشركات الاستضافة ومراكز البيانات"
    },
    "perMonth": "لكل سيرفر شهريًا",
    "perMonthYearly": "لكل سيرفر شهريًا، الدفع سنوي",
    "accounts_zero": "بدون حسابات استضافة",
    "accounts_one": "حساب استضافة واحد",
    "accounts_two": "حتى حسابي استضافة",
    "accounts_few": "حتى {{n}} حسابات استضافة",
    "accounts_many": "حتى {{n}} حساب استضافة",
    "accounts_other": "حتى {{n}} حساب استضافة",
    "aiCredits": "{{n}} نقطة ذكاء اصطناعي شهريًا",
    "allFeatures": "كل مزايا bPanel",
    "extras": {
      "reseller": "الموزعون مع حصة لكل موزع",
      "whiteLabel": "علامتك التجارية على اللوحة",
      "extraAccount": "كل حساب إضافي بـ"
    },
    "featured": "الأنسب لشركات الاستضافة",
    "featuredShort": "الأنسب",
    "current": "باقتك الحالية",
    "choose": "اختر الباقة",
    "vat": "الأسعار بالريال السعودي ولا تشمل ضريبة القيمة المضافة. تحسب Dodo Payments الضريبة في الفاتورة.",
    "yourPrice": "سعرك"
  },
  "ui": {
    "loading": "جارٍ التحميل",
    "optional": "اختياري",
    "breadcrumbs": "مسار التنقل",
    "notifications": "الإشعارات",
    "password": {
      "show": "إظهار كلمة المرور",
      "hide": "إخفاء كلمة المرور",
      "strength": {
        "empty": "قوة كلمة المرور",
        "weak": "ضعيفة",
        "fair": "مقبولة",
        "good": "جيدة",
        "strong": "قوية"
      }
    },
    "otp": {
      "label": "رمز التحقق",
      "digit": "الرقم {{n}} من {{total}}"
    },
    "select": {
      "placeholder": "اختر"
    },
    "combobox": {
      "search": "ابحث",
      "empty": "لا توجد نتائج"
    },
    "usage": {
      "ofTotal": "{{used}} من {{total}}"
    },
    "meter": {
      "ofTotal": "من {{total}}",
      "included": "{{n}} من الباقة",
      "extra": "{{n}} إضافية",
      "used": "{{n}} مستخدمة"
    },
    "table": {
      "search": "ابحث",
      "all": "الكل",
      "clearFilters": "مسح الفلاتر",
      "empty": "لا توجد بيانات بعد",
      "noResults": "لا توجد نتائج",
      "noResultsHint": "جرّب كلمات بحث أو فلاتر أخرى.",
      "actions": "إجراءات"
    },
    "pagination": {
      "label": "التنقل بين الصفحات",
      "range": "{{from}} إلى {{to}} من {{total}}",
      "previous": "السابق",
      "next": "التالي"
    },
    "confirm": {
      "typeToConfirm": "للتأكيد، اكتب"
    },
    "secret": {
      "reveal": "إظهار",
      "hide": "إخفاء"
    },
    "stepper": {
      "label": "الخطوة {{n}} من {{total}}"
    }
  },
  "placeholder": {
    "soon": "قريبًا",
    "title": "هذه الصفحة لم تُنشر بعد",
    "legal": "صفحتا الشروط والخصوصية ستكونان متاحتين قريبًا على bpanel.dev."
  }
}
